<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1n">
<div id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" src="image/cover.jpg"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-1" src="image/ht.jpg"/></div></div>
<div style="page-break-after: always;"> </div>
<div class="Basic-Text-Frame" id="_idContainer002">
<p class="Normal ParaOverride-1"><span class="CharOverride-1">Other Baby Blues</span><span class="CharOverride-2">®</span><span class="CharOverride-1"> Books from Andrews McMeel Publishing</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Guess Who Didn’t Take a Nap?</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">I Thought Labor Ended When the Baby Was Born</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">We Are Experiencing Parental Difficulties . . . Please Stand By</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Night of the Living Dad</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">I Saw Elvis in My Ultrasound</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">One More and We’re Outnumbered!</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Check, Please . . .</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">threats, bribes &amp; videotape</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">If I’m a Stay-at-Home Mom, Why Am I Always in the Car?</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Lift and Separate</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">I Shouldn’t Have to Scream More Than Once!</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Motherhood Is Not for Wimps</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Baby Blues</span><span class="CharOverride-4">®</span><span class="CharOverride-3">: Unplugged</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Dad to the Bone</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Never a Dry Moment</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Two Plus One Is Enough</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Playdate: Category 5</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Our Server Is Down</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Something Chocolate This Way Comes</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Briefcase Full of Baby Blues</span><span class="CharOverride-4">®</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Night Shift</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">The Day Phonics Kicked In</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">My Space</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">The Natural Disorder of Things</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">We Were Here First</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Ambushed! In the Family Room</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Cut!</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Eat, Cry, Poop</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Scribbles at an Exhibition</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Bedlam</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Wetter, Louder, Stickier</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-1">Treasuries</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">The Super-Absorbent Biodegradable Family-Size Baby Blues</span><span class="CharOverride-4">®</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Baby Blues</span><span class="CharOverride-4">®</span><span class="CharOverride-3">: Ten Years and Still in Diapers</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Butt-Naked Baby Blues</span><span class="CharOverride-4">®</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Wall-to-Wall Baby Blues</span><span class="CharOverride-4">®</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Driving Under the Influence of Children</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">Framed!</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">X-Treme Parenting</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">BBXX: Baby Blues: Decades 1 and 2 </span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-1">Gift Book</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">It’s a Boy</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-3">It’s a Girl</span></p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NoYelling_EPUB.vue?325189bb